import { applyMiddleware, combineReducers, createStore as reduxCreateStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';

const loggerMiddleware = createLogger();

export const createStore = reducers =>
    reduxCreateStore(
        combineReducers(reducers),
        composeWithDevTools(applyMiddleware(thunkMiddleware, loggerMiddleware))
    );
